export default "__VITE_ASSET__DnAvbfqQ__"